/// <summary>
/// dashboard visual for a simple signal 
/// Author: AFU<br />
/// Date: 13.8.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 -  13.8.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardPie", jQuery.common.vcBaseV4, {


    _create: function () {
        this._createVisual(417);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-data");
            me.myRoot.css("height", "100%");
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   
    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        var me = this;
        try {
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "dashboard-pie").css({ "width": "100%", "height": "100%", "overflow": "hidden", "display": "flex", "flexDirection": "row" });
            me.myHtml.chart = $("<div>").addClass("dashboard-pie-chart").css({ "width": "100%", "height": "100%", "minWidth": "0" });
            me.myHtml.list = $("<div>").addClass("dashboard-pie-list").css({ "height": "100%", "overflowY": "auto", "overflowX": "hidden", "display": "none", "boxSizing": "border-box", "flexDirection": "column", "justifyContent": "center", "minWidth": "0" });
            me.myHtml.wrapper.append(me.myHtml.chart, me.myHtml.list);
            me.myRoot.html(me.myHtml.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
 

    _fetch: function () {
        var me = this;
        try {
            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, SumValues:true }, function (result) {
                if (result === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                me._loadChart(result);
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _loadChart: function (result) {
        var me = this;
        try {

            var showDataTable = !!(me.settings && me.settings.parameter && me.settings.parameter.ShowDataTable);

            var entries = [];
            $.each(result.Entries, function (i, s) {
                entries.push({
                    name: $('<div>').html(s.Name).text(),
                    unit: s.Unit,
                    value: (s.Status > -1 ? s.Value : 0)
                });
            });

            var seriesList = [];
            seriesList.push({
                type: 'pie',
                name: '',
                size: showDataTable ? '85%' : '65%',
                data: [],
                showInLegend: !showDataTable,
                dataLabels: { enabled: !showDataTable, useHTML: true, format: '{point.percentage:.1f} %' }
            });

            $.each(entries, function (i, e) {
                seriesList[0].data.push({ name: e.name + ' [' + e.unit + ']', y: e.value });
            });

            var chartOptions = { type: 'pie' };
            if (showDataTable) {
                chartOptions.spacing = [4, 4, 4, 4];
            }

            var options = {
                chart: chartOptions,
                title: { text: null },
                legend: { useHTML: true, labelFormatter: function () { var text = $('<div>').html(this.name).text(); return '<span title="' + text.replace(/"/g, '&quot;') + '">' + this.name + '</span>'; } },
                tooltip: {
                    useHTML: true,
                    backgroundColor: '#ffffff',
                    borderColor: '#cccccc',
                    borderWidth: 1,
                    style: { opacity: '1' },
                    formatter: function () {
                        return this.key + '<br/><b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b> (' + Highcharts.numberFormat(this.percentage, 1, ',', '.') + ' %)';
                    }
                },
                series: seriesList
            };

            if (showDataTable) {
                options.legend.enabled = false;
            }

            var ro = new RampOptions();
            var availableHeight = me.element.closest(".dashboard-charts-wrapper").height() || me.element.closest(".grid-stack-item-content").height() || me.myRoot.parent().height() || 300;
            me.myRoot.height(availableHeight);

            if (showDataTable) {
                me.myHtml.chart.css({ "width": "40%", "flex": "0 0 40%", "minWidth": "0" });
                me.myHtml.list.css({ "width": "60%", "flex": "0 0 60%", "minWidth": "0", "padding": "0", "display": "flex", "boxSizing": "border-box" }).show();
                me.myHtml.list.height(availableHeight);
            } else {
                me.myHtml.chart.css({ "width": "100%", "flex": "1 1 100%" });
                me.myHtml.list.hide().empty();
            }

            me.myHtml.chart.height(availableHeight);
            var chart = me.myHtml.chart.highcharts($.extend({}, ro.getTheme(), options)).highcharts();

            if (showDataTable && chart) {
                me._buildDataList(entries, chart);
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _formatNumber: function (number, decimals) {
        var n = parseFloat(number);
        if (isNaN(n)) n = 0;
        var parts = n.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return decimals > 0 ? parts[0] + "," + parts[1] : parts[0];
    },

    _buildDataList: function (entries, chart) {
        var me = this;
        try {
            var total = 0;
            $.each(entries, function (i, e) { total += (parseFloat(e.value) || 0); });

            // Determine the width of the value column based on the longest formatted absolute value (incl. total).
            var maxValueLength = me._formatNumber(total, 2).length;
            var maxUnitLength = 0;
            $.each(entries, function (i, e) {
                var len = me._formatNumber(parseFloat(e.value) || 0, 2).length;
                if (len > maxValueLength) maxValueLength = len;
                var unitLen = (e.unit || "").length;
                if (unitLen > maxUnitLength) maxUnitLength = unitLen;
            });
            var valueColumnWidth = (maxValueLength + 1) + "ch";
            var unitColumnWidth = (maxUnitLength + 1) + "ch";

            var $content = $("<div>").css({ "width": "100%", "minWidth": "0" });
            var $table = $("<table>").css({ "width": "100%", "maxWidth": "100%", "tableLayout": "fixed", "borderCollapse": "collapse" });
            var $tbody = $("<tbody>");

            $.each(entries, function (i, e) {
                var color = (chart && chart.series[0].data[i]) ? chart.series[0].data[i].color : "#cccccc";
                var value = parseFloat(e.value) || 0;
                var percentage = total > 0 ? (value / total * 100) : 0;

                var $colorCell = $("<td>").css({ "padding": "4px 6px 4px 0", "overflow": "hidden" })
                    .append($("<span>").css({ "display": "inline-block", "width": "10px", "height": "10px", "borderRadius": "2px", "backgroundColor": color, "marginRight": "6px", "verticalAlign": "middle", "flexShrink": "0" }))
                    .append($("<span>").text(e.name).css({ "verticalAlign": "middle", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "display": "inline-block", "maxWidth": "calc(100% - 20px)" }))
                    .attr("title", e.name);

                var $percentCell = $("<td>").text(me._formatNumber(percentage, 1) + " %").css({ "padding": "4px", "textAlign": "right", "color": "#888", "whiteSpace": "nowrap", "width": "16%" });
                var $valueCell = $("<td>").text(me._formatNumber(value, 2)).css({ "padding": "4px", "textAlign": "right", "fontWeight": "bold", "whiteSpace": "nowrap", "width": valueColumnWidth });
                var $unitCell = $("<td>").text(e.unit || "").css({ "padding": "4px 0 4px 6px", "textAlign": "left", "color": "#888", "whiteSpace": "nowrap", "width": unitColumnWidth });

                $tbody.append($("<tr>").append($colorCell, $percentCell, $valueCell, $unitCell));
            });

            $table.append($tbody);

            var $tfoot = $("<tfoot>");
            var $totalRow = $("<tr>");
            $totalRow.append($("<td>").css({ "padding": "8px 6px 0 0" }));
            $totalRow.append($("<td>").css({ "padding": "8px 4px 0 4px" }));
            $totalRow.append($("<td>").css({ "padding": "8px 4px 0 4px", "textAlign": "right", "fontWeight": "bold", "borderTop": "1px solid #ccc", "whiteSpace": "nowrap" }).text(me._formatNumber(total, 2)));
            $totalRow.append($("<td>").css({ "padding": "8px 0 0 6px" }));
            $tfoot.append($totalRow);
            $table.append($tfoot);

            $content.append($table);
            me.myHtml.list.empty().append($content);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});